import React from 'react';

const FormField = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  error,
  showPasswordToggle = false,
  showPassword = false,
  onTogglePassword,
  children,
  className = '',
  style = {}
}) => {
  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-jet-gray-700 mb-2">
          {label} {required && <span className="text-jet-red-500">*</span>}
        </label>
      )}
      
      <div className="relative">
        <input
          type={showPasswordToggle ? (showPassword ? 'text' : 'password') : type}
          name={name}
          value={value}
          onChange={onChange}
          style={style}
          className={`password-field w-full px-3 py-2 border rounded-md focus:outline-none transition-colors ${
            showPasswordToggle ? 'pr-10' : ''
          } ${
            error 
              ? 'border-jet-red-400 focus:border-jet-red-500' 
              : 'border-jet-gray-300 focus:border-jet-yellow'
          }`}
          placeholder={placeholder}
          required={required}
        />
        
        {showPasswordToggle && (
          <button
            type="button"
            onClick={onTogglePassword}
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
          >
            <svg className="h-5 w-5 text-jet-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {showPassword ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              )}
            </svg>
          </button>
        )}
      </div>
      
      {children}
      
      {error && (
        <p className="mt-1 text-sm text-jet-red-600">{error}</p>
      )}
    </div>
  );
};

export default FormField;